import React, { useState, useEffect } from 'react';
import { Box, Typography, MenuItem } from '@mui/material';
import { CustomSelect } from '../../../MUI_custom_component';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const QuarterCard = ({ quarter }) => {
  const hasQualifyText = Boolean(quarter?.qualify_text);

  return (
    <Box
      sx={{
        backgroundColor: '#FFFFFF',
        borderRadius: '16px',
        px: 2,
        py: hasQualifyText ? 1 : 2,
        display: 'flex',
        alignItems: hasQualifyText ? 'flex-start' : 'center',
        justifyContent: 'space-between',
      }}
    >
      <Typography variant='labelS' sx={{ color: '#333' }}>
        {quarter?.quarter_label}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
        <Typography variant='labelS' sx={{ color: '#333', whiteSpace: 'nowrap' }}>
          {quarter?.quarter_amount}
        </Typography>
        {hasQualifyText && (
          <Typography variant='p4' sx={{ color: '#8C8C8C', whiteSpace: 'nowrap' }}>
            {quarter?.qualify_text}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

const FYDetailsSection = ({ fyDetails = [], subject_to_tds }) => {
  const [selectedFY, setSelectedFY] = useState(fyDetails?.[0]?.financial_year || '');

  useEffect(() => {
    if (fyDetails?.[0]?.financial_year) {
      setSelectedFY(fyDetails[0].financial_year);
    }
  }, [fyDetails]);

  const selectedData = fyDetails?.find((fy) => fy.financial_year === selectedFY) || fyDetails?.[0] || null;
  const quarters = selectedData?.gross_gap_summary?.quarters || [];
  const total = selectedData?.total;
  const sectionTitle = selectedData?.gross_gap_summary?.title;

  if (!fyDetails || fyDetails.length === 0) {
    return (
      <Typography variant='body1' sx={{ color: '#666', p: 2, textAlign: 'center' }}>
        No data available
      </Typography>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <CustomSelect
        label='Financial Year'
        size='small'
        width='100%'
        value={selectedFY}
        onChange={(e) => setSelectedFY(e.target.value)}
      >
        {fyDetails.map((fy) => (
          <MenuItem key={fy.financial_year} value={fy.financial_year}>
            {fy.financial_year}
          </MenuItem>
        ))}
      </CustomSelect>

      {sectionTitle && (
        <Typography variant='labelD'>
          {sectionTitle}
        </Typography>
      )}

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {quarters.map((quarter,i) => (
          <QuarterCard key={i} quarter={quarter} />
        ))}

        {total && (
          <Box
            sx={{
              backgroundColor: 'rgba(0,128,0,0.08)',
              borderRadius: '16px',
              px: 2,
              py: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography variant='labelM' sx={{ color: '#333' }}>
              {total.label}
            </Typography>
            <Typography variant='labelM' sx={{ color: '#333', whiteSpace: 'nowrap' }}>
              {total.value}
            </Typography>
          </Box>
        )}

        {subject_to_tds && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <WarningAmberIcon sx={{ fontSize: 16, color: '#CC0000', flexShrink: 0 }} />
          <Typography variant="p3" sx={{ color: '#CC0000', whiteSpace: 'nowrap' }}>
            {subject_to_tds}
          </Typography>
        </Box>
      )}
      </Box>
    </Box>
  );
};

export default FYDetailsSection;
